import client_config from '@/assets/json/client_config.json'
import { default as client_lookups } from '@/assets/json/clientLookups.json'
import router from '@/router'
import { default as axiosInstance } from '@/services'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

async function handleExemptionsLogic() {
  const formStore = useFormStore()
  const { sponsorNumber } = formStore.form.values
  if (!sponsorNumber) return

  const exemptions = await axiosInstance.get('/api/sponsor/getExemptionsTypeFlag', {
    params: {
      unifiednumber: sponsorNumber,
      validateExemptions: true
    }
  })
  formStore.extraMap.exemptionsTypeFlag = exemptions.exemptionsTypeFlag
  switch (exemptions.exemptionsTypeFlag) {
    case 1:
      formStore.draft.request.freeDepositCaseId = 1
      formStore.extraMap.disableFreeDepositCaseId = true
      break
    case 2:
      formStore.draft.request.freeDepositCaseId = 3
      formStore.extraMap.disableFreeDepositCaseId = true
      break
    default:
      formStore.draft.request.freeDepositCaseId = null
      formStore.extraMap.disableFreeDepositCaseId = false
      break
  }
}

async function getViolatedFiles() {
  const {
    params: { serviceId }
  } = router.currentRoute.value

  const formStore = useFormStore()
  const {
    sponsorUnifiedNumber,
    personUnifiedNumber,
    fileDepartmentCode,
    fileYear,
    fileTypeCode,
    fileSequenceNumber,
    sponsorTypeId,
    sponsorImmigrationId
  } = formStore.form.values

  if (!personUnifiedNumber) return

  const params = {
    sponsorUnifiedNumber,
    personUnifiedNumber,
    fileDepartmentCode,
    fileYear,
    fileTypeCode,
    fileSequenceNumber,
    sponsorTypeId,
    sponsorImmigrationId,
    serviceTransId: serviceId
  }

  try {
    const fines = await axiosInstance.get('/api/bulkRequest/violatedFiles', {
      params
    })

    if ((fines || []).length > 0) {
      console.info('[getViolatedFiles] show error message')
    }
  } catch (error) {
    console.error('[getViolatedFiles]', error)
  }
}

async function getWorkSeekerLogic() {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()

  const {
    request: { visaHolderUnifiedNumber }
  } = formStore.draft

  const { personUnifiedNumber: unifiednumber, isBeneficiariesofFinesExemptions } =
    formStore.form.values || formStore.draft.request
  const { isWorkSeekerVisaAccompany } = globalStore.startedService

  if (!unifiednumber) return

  const userInfo = await axiosInstance.get('/api/user/usersInfoByUnifiedNumber', {
    params: {
      unifiednumber,
      fileStatusId: 0
    }
  })

  const hasNoRecord = (userInfo || []).length <= 0
  const [{ isOutsideCountry, sponsorNumber, mohleBenifetFlag, isViolatedFlag }] =
    userInfo.collection
  if (hasNoRecord || isOutsideCountry) {
    //In order to be able to smoothly proceed to the next step (There is no suitable data)
    // TODO: formStore.form.setFieldValue('personUnifiedNumber', null)
    console.info('[getWorkSeekerLogic] TODO: notMatching')
  }

  if (sponsorNumber != visaHolderUnifiedNumber) {
    Object.assign(formStore.draft.request, { isWorkSeekerVisaAccompanyAttachmentMandatory: true })
  }

  if (mohleBenifetFlag) {
    Object.assign(formStore.draft.request, { isBeneficiariesofFinesExemptions: true })

    if (!isOutsideCountry) {
      await getActiveVisas()
    }
  }

  const isNotMohleBenifetFlagAndIsOutside = !mohleBenifetFlag && isOutsideCountry
  const isBeneficiaryOfFineExemptionAndIsWorkSeeker =
    isBeneficiariesofFinesExemptions && !isWorkSeekerVisaAccompany
  if (isNotMohleBenifetFlagAndIsOutside || isBeneficiaryOfFineExemptionAndIsWorkSeeker) {
    console.info('[getWorkSeekerLogic] TODO: show error message NOT_ELIGIBLE_TO_APPLY')
  }

  if (isViolatedFlag) {
    Object.assign(formStore.draft.request, {
      isBeneficiariesofFinesExemptions: false,
      personUnifiedNumber: null
    })
    console.info('[getWorkSeekerLogic] TODO: personHasFinePayFirst')
  }
}

async function hideSponsorInformationIfVirtualAndVisa() {
  const formStore = useFormStore()
  const {
    params: { serviceId }
  } = router.currentRoute.value
  const { personUnifiedNumber, departmentCode, serviceYear, serviceCode, sequenceNumber } =
    formStore.form.values

  if (!personUnifiedNumber) return

  const {
    ServiceTransactions: { VisaDataModification, cancelVisa, exceptionalCancelVisa }
  } = client_lookups

  const params = {
    personUnifiedNumber,
    moduleId: 2,
    serviceTransactionId: serviceId,
    ...(departmentCode && { departmentCode }),
    ...(serviceYear && { serviceYear }),
    ...(serviceCode && { serviceCode }),
    ...(sequenceNumber && { sequenceNumber })
  }

  const response = await axiosInstance.get('/api/user/checkIfVirtualSponsorByUniNumOrFileNumber', {
    params
  })

  const isVisa = [VisaDataModification, cancelVisa, exceptionalCancelVisa].includes(+serviceId)
  Object.assign(formStore.extraMap, { hideSponsorInformation: isVisa || response.isVirtualSponsor })
}

async function handleUserNationality() {
  const formStore = useFormStore()
  const {
    params: { serviceId }
  } = router.currentRoute.value

  const { personUnifiedNumber } = formStore.form.values || formStore.draft.request

  if (!personUnifiedNumber) return

  const {
    ServiceTransactions: { issueShortTermVisaForEntrepreneurs },
    checkIfVisitVisaForRelativeOrFriend,
    checkIfExtendVisitVisaForRelativeOrFriend,
    gccNationalityId
  } = client_lookups

  const services = [
    issueShortTermVisaForEntrepreneurs,
    ...checkIfVisitVisaForRelativeOrFriend,
    ...checkIfExtendVisitVisaForRelativeOrFriend
  ]

  if (services.includes(serviceId) === false) return

  const params = {
    unifiednumber: personUnifiedNumber,
    fileStatusId: 0
  }

  const response = await axiosInstance.get('/api/user/usersNationalityByUnifiedNumber', {
    params
  })

  if (gccNationalityId.includes(response)) {
    console.info('[handleUserNationality] TODO: notEligableToApplyService')
    formStore.form.setFieldValue('personUnifiedNumber', null)
  }
}

async function handleExceptionalCase(personUnifiedNumber) {
  const path = `/api/draft/checkExceptionalCase/${personUnifiedNumber}`
  const response = await axiosInstance.get(path)

  /**
   * web/shared/exceptionSponsorType/exceptionSponsorTypeCtrl.js
   * $scope.checkExceptionalCase
   */
  console.info('[handleExceptionalCase] TODO: implement me')
}

async function checkSponsorFile() {
  const formStore = useFormStore()

  formStore.extraMap.showSponsorFileWarningMessage = false

  const {
    query: { administrativeRegionId }
  } = router.currentRoute.value

  const { sponsorNumber, sponsorTypeId } = formStore.form.values || formStore.draft.request

  const params = {
    unifiedNumber: sponsorNumber,
    administrativeRegion: administrativeRegionId ?? 1,
    sponsorTypeId
  }

  const response = await axiosInstance.get('/api/bulkRequest/individual/checkSponsorFile', {
    params
  })

  return response
}

async function getActiveVisas() {
  const formStore = useFormStore()
  const {
    params: { serviceId }
  } = router.currentRoute.value
  const { personUnifiedNumber } = formStore.form.values || formStore.draft.request

  const params = {
    personUnifiedNumber,
    serviceId
  }

  const activeVisas = await axiosInstance.get('/api/typingCenter/request/checkPersonActiveVisas', {
    params
  })

  if (activeVisas.errorCode === 0) {
    console.info('[getActiveVisas] TODO: show error message HaveInProgressWorkSeekerVisa')
    formStore.form.setFieldValue('personUnifiedNumber', null)
    Object.assign(formStore.draft.request, { personUnifiedNumber: null })
  }
}

function resetWarnings() {
  const formStore = useFormStore()
  Object.assign(formStore.extraMap, {
    showHostSponsorFileWarningMessage: false,
    showSponsorFileWarningMessage: false,
    sponsorFileWarningMessage: null,
    hostSponsorFileWarningMessage: null
  })
}

function isCancellingDueToDeath() {
  const {
    params: { serviceId }
  } = router.currentRoute.value

  const {
    requestCancelTransaction: { visaCancel },
    transactionReason: { visaDeadInsideCoutry }
  } = client_lookups

  return [visaCancel, visaDeadInsideCoutry].includes(serviceId)
}

async function processBeneficiaryUnifiedNumber() {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()

  const {
    params: { serviceId }
  } = router.currentRoute.value

  const { isWorkSeekers, isWorkSeekerVisaAccompany } = globalStore.startedService
  const { personUnifiedNumber } = formStore.form.values || formStore.draft.request
  const {
    request: { isBeneficiariesofFinesExemptions }
  } = formStore.draft
  const {
    requestCancelTransaction: { exceptionalVisaCancel }
  } = client_lookups

  // need compare visa with residency
  // TODO: await handleExceptionalCase(personUnifiedNumber)

  const shouldGetExemptions = [1, 9, 39, 56, 105, 107, 367].includes(serviceId)
  if (!!personUnifiedNumber && shouldGetExemptions) {
    await handleExemptionsLogic()
  }

  // TODO: if dead, clear and return

  const isNotWorkSeeker =
    !isBeneficiariesofFinesExemptions && !isWorkSeekers && !isWorkSeekerVisaAccompany
  if (isNotWorkSeeker && serviceId != exceptionalVisaCancel) {
    await getViolatedFiles()
  }

  await getWorkSeekerLogic()
  await hideSponsorInformationIfVirtualAndVisa()
  await handleUserNationality()

  // const sponsorFileResponse = await checkSponsorFile()

  // if (!sponsorFileResponse?.success) {
  //   Object.assign(formStore.extraMap, {
  //     showSponsorFileWarningMessage: true,
  //     sponsorFileWarningMessage: sponsorFileResponse.errorMessage || 'addSponsorFileMessage'
  //   })
  // }
}

async function processHostUnifiedNumber() {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()
  const {
    params: { serviceId }
  } = router.currentRoute.value
  const { isWorkSeekers, isWorkSeekerVisaAccompany } = globalStore.startedService

  const { enableResidencyViolatorsWithoutFeesServices } = client_config

  const {
    sponsorNumber,
    sponsorTypeId,
    sponsorDepartmentId,
    isBeneficiariesofFinesExemptions,
    applicantIdentityNumber
  } = formStore.form.values || formStore.draft.request

  // if any of these are null, return
  if ([sponsorNumber, sponsorTypeId, sponsorDepartmentId].some((s) => !s)) return

  if (!isBeneficiariesofFinesExemptions && !isWorkSeekers) {
    const {
      ServiceTransactions: {
        extendVisaForGCC,
        extendVisaForGCCResident,
        checkIfVisitVisaForRelativeOrFriend,
        checkIfExtendVisitVisaForRelativeOrFriend
      },
      requestCancelTransaction: { exceptionalVisaCancel }
    } = client_lookups

    const transactionsToSkip = [
      extendVisaForGCC,
      extendVisaForGCCResident,
      checkIfVisitVisaForRelativeOrFriend,
      checkIfExtendVisitVisaForRelativeOrFriend
    ]

    if (transactionsToSkip.includes(serviceId)) {
      return
    }

    const sponsorFileResponse = await checkSponsorFile()

    if (!sponsorFileResponse?.success) {
      Object.assign(formStore.extraMap, {
        showHostSponsorFileWarningMessage: true,
        hostSponsorFileWarningMessage: sponsorFileResponse?.errorMessage || 'addSponsorFileMessage'
      })
    }

    if (applicantIdentityNumber && enableResidencyViolatorsWithoutFeesServices) {
      const payload = {
        departmentId: sponsorDepartmentId,
        estabNumber: sponsorNumber,
        applicantIdentityNumber: applicantIdentityNumber
      }

      try {
        const estabNameAndRelatedPerson = await axiosInstance.post(
          '/api/establishment/estabNameAndRelatedPerson',
          payload
        )
        if (!estabNameAndRelatedPerson?.isRelatedPerson) {
          console.info(
            '[processHostUnifiedNumber] TODO: show error popup ApplicantNOTAllowedToApply'
          )
          formStore.form.setValues({
            sponsorNumber: null,
            sponsorTypeId: null,
            sponsorDepartmentId: null,
            sponsorEnglishName: null,
            sponsorArabicName: null
          })
        }
      } catch (error) {
        console.info('[processHostUnifiedNumber] TODO: show error popup noDataFound')
      }
    }

    // TODO: if dead, clear and return
    if (isCancellingDueToDeath()) {
      resetWarnings()
      return
    }

    const isNotWorkSeeker =
      !isBeneficiariesofFinesExemptions && !isWorkSeekers && !isWorkSeekerVisaAccompany
    if (isNotWorkSeeker && serviceId != exceptionalVisaCancel) {
      await getViolatedFiles()
    }

    if (isWorkSeekerVisaAccompany) {
      getWorkSeekerLogic()
    }
  }
}

async function onTCGenderChange() {
  const formStore = useFormStore()
  const { genderId = '' } = formStore.form.values
  const {
    gender: { male },
    professions: { child, femaleChild }
  } = client_lookups
  if (genderId == male) {
    formStore.draft.request.professionId = genderId == male ? child : femaleChild
  }
}

function onTCtransactionReasonChange() {
  const formStore = useFormStore()
  const { transactionReasonId = '', workPlaceEstablishmentDepartmentId = '' } =
    formStore.form.values
  const {
    talentedPeopleNotRequireWorkplace,
    reasonsRequiresThreeSectionEstabNumber,
    mainDepartments: { dubai }
  } = client_lookups
  const { optionalNominationRequestForTransactionReasons } = client_config
  formStore.extraMap.showApplyByNomination = false
  if (
    !talentedPeopleNotRequireWorkplace.includes(transactionReasonId) &&
    reasonsRequiresThreeSectionEstabNumber.includes(transactionReasonId) &&
    workPlaceEstablishmentDepartmentId == dubai
  ) {
    formStore.draft.request.isReasonRequiresThreeSectionEstabNumber = true
  }

  if (optionalNominationRequestForTransactionReasons.some((e) => e == transactionReasonId)) {
    formStore.extraMap.showApplyByNomination = true
  }
}

function onTCEstablishmentDepartmentChange() {
  const formStore = useFormStore()
  const serviceId = +(
    router.currentRoute?.value?.params?.serviceId ||
    useGlobalStore().startService.serviceTransactionId
  )
  const { transactionReasonId = '', workPlaceEstablishmentDepartmentId = '' } =
    formStore.form.values || {}
  const {
    ServiceTransactions: {
      goldenResidencyVisaForHumanitarianPioneersIssue,
      decree28_PersonsWhoAreTalented,
      goldenResidenceScientistsandSpecialists
    },
    reasonsRequiresThreeSectionEstabNumber,
    mainDepartments: { dubai }
  } = client_lookups
  const isServiceValid = [
    goldenResidencyVisaForHumanitarianPioneersIssue,
    decree28_PersonsWhoAreTalented,
    goldenResidenceScientistsandSpecialists
  ].includes(serviceId)
  if (
    isServiceValid &&
    reasonsRequiresThreeSectionEstabNumber.includes(transactionReasonId) &&
    workPlaceEstablishmentDepartmentId == dubai
  ) {
    formStore.draft.request.isReasonRequiresThreeSectionEstabNumber = true
    return
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    establishmentNumber: undefined,
    workPlaceEstablishmentType: undefined,
    workPlaceEstablishmentSponsorType: undefined,
    isReasonRequiresThreeSectionEstabNumber: undefined
  }
}
function filterTCAdministrativeRegions(options) {
  const {
    adminRegions: { dubai }
  } = client_lookups
  return options.filter((e) => e.id != dubai)
}

function filterTCDepartments(options) {
  const serviceId = +(
    router.currentRoute?.value?.params?.serviceId ||
    useGlobalStore().startService.serviceTransactionId
  )
  const {
    mainDepartments: { dubai },
    virtualResidencyVisaServices
  } = client_lookups
  if (virtualResidencyVisaServices.includes(serviceId)) {
    return options.filter((e) => e.id != dubai)
  }
  return options
}

function onTCBirthCountryChange() {
  const formStore = useFormStore()
  const serviceId = +(
    router.currentRoute?.value?.params?.serviceId ||
    useGlobalStore().startService.serviceTransactionId
  )
  const { countryOfBirthId = '' } = formStore.form.values || {}
  const { identityVisaServices } = client_config
  const { emirateNationality } = client_lookups
  if (identityVisaServices.includes(serviceId)) {
    formStore.extraMap.showLocalAddressDetails = countryOfBirthId == emirateNationality
    if (!formStore.extraMap.showLocalAddressDetails) {
      formStore.draft.request = {
        ...formStore.draft.request,
        sponsoredBirthEmirateId: '',
        sponsoredBirthAddress: '',
        sponsoredBirthCityId: ''
      }
    }
  }
}

/**
 * used in
 * role: typing center
 * service: [24] VISA - MULTIPLE ENTRY - TREATMENT 90 Days - ISSUE NEW VISA
 */
export default function () {
  return {
    processBeneficiaryUnifiedNumber,
    processHostUnifiedNumber,
    resetWarnings,
    onTCGenderChange,
    onTCtransactionReasonChange,
    onTCEstablishmentDepartmentChange,
    filterTCAdministrativeRegions,
    filterTCDepartments,
    onTCBirthCountryChange
  }
}
